import React from 'react'
import CertificatesApp from '../../components/certificates/certificatesapp'
import Navbar from '../../components/navbar/Navbar'
import Profile from '../../components/profile.js/profile'
import ProjectApp from '../../components/projects/projectapp'
import SkillApp from '../../components/skills/skillapp'

function Home (){

    return(
        <>
        <Navbar />
        <Profile />
        <ProjectApp />
        <SkillApp />
        <CertificatesApp />
        </>
    )
}
export default Home